const _ = require('lodash'), templates = require('./inline-messages');

const InlineMessageService = function ($templateCache, currencyFilter, $sce) {
    this.$sce = $sce;

    _.forEach(templates, function (template) {
        $templateCache.put(template.id, template.content);
    });

    this._currencyFilter = currencyFilter;

    this.InlineMessages = {};

};

InlineMessageService.prototype._addInlineMessage = function (stockcode, type, message, isDismissed) {
    if (!this.InlineMessages[stockcode]) {
        this.InlineMessages[stockcode] = {};
    }
    this.InlineMessages[stockcode][type] = { stockcode, type, message, isDismissed };
};

InlineMessageService.prototype._removeInlineMessage = function (stockcode, type) {
    if (!this.InlineMessages[stockcode]) {
        return false;
    }
    delete this.InlineMessages[stockcode][type];
};

InlineMessageService.prototype._getInlineMessage = function (stockcode, type) {
    if (!this.InlineMessages[stockcode]) {
        return null;
    }
    return this.InlineMessages[stockcode][type];
};

InlineMessageService.prototype._getMostRecentInlineMessage = function (stockcode, isDismissed) {
    const inlineMessages = this.InlineMessages[stockcode];

    // No inline messages for this stockcode
    if (!inlineMessages) {
        return null;
    }
    const types = Object.keys(inlineMessages);
    if (types.length < 1) {
        return null;
    }

    // Return the most recent object which matches 'isDismissed'
    for (let i = types.length - 1; i > -1; i--) {
        const lastType = types[i];
        if (inlineMessages[lastType].isDismissed === isDismissed) {
            return inlineMessages[lastType];
        }
    }

    return null;
};

InlineMessageService.prototype.addInlineMessage = function (stockcode, type, message, isNew) {
    const inlineMessage = this._getInlineMessage(stockcode, type);
    const isEmpty = typeof message === 'undefined' || message === null || message === '';

    // Does the message exist for this stockcode and type
    if (typeof inlineMessage !== 'undefined' && inlineMessage !== null) {
        // If message has changed, display it again.
        if (!_.isEqual(inlineMessage.message, message) || isNew) {
            inlineMessage.isDismissed = false;
            inlineMessage.message = message;
        }

        // Remove item if message is empty
        if (isEmpty) {
            this._removeInlineMessage(stockcode, type);
        }
    } else {
        if (!isEmpty) {
            this._addInlineMessage(stockcode, type, message, false);
        }
    }
};

InlineMessageService.prototype.removeInlineMessage = function (stockcode, type) {
    const inlineMessage = this._getInlineMessage(stockcode, type);
    if (inlineMessage) {
        this._removeInlineMessage(stockcode, type);
    }
};

InlineMessageService.prototype.dismissMessage = function (message) {
    const inlineMessage = this._getInlineMessage(message.stockcode, message.type);
    if (inlineMessage) {
        inlineMessage.isDismissed = true;
    }
};

InlineMessageService.prototype.getMostRecentInlineMessage = function (trolleyItem) {
    if (!trolleyItem.IsAvailable) {
        return null;
    }
    const inlineMessage = this._getMostRecentInlineMessage(trolleyItem.Stockcode, false);
    return inlineMessage || null;
};


InlineMessageService.prototype.initMissedPromotions = function (trolleyItem) {
    // Missed multibuy promotion
    const missedPromotion = _.find(trolleyItem.MissedPromotions, function (promotion) { return promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff; });
    if (missedPromotion) {
        this.addInlineMessage(trolleyItem.Stockcode, 'MissedPromotion', {
            isDismissable: true,
            class: 'missedPromotion',
            templateId: 'missed-promotion',
            promotionDescription: missedPromotion.Description,
            promotionLink: missedPromotion.CustomUrl || missedPromotion.Link
        });
    } else {
        this.removeInlineMessage(trolleyItem.Stockcode, 'MissedPromotion');
    }
};

InlineMessageService.prototype.initMatchedPromotions = function (trolleyItem) {
    // Matched multibuy promotion
    const matchedPromotion = _.find(trolleyItem.MatchedPromotions, function (promotion) { return promotion.IsMultiBuy || promotion.IsPackagePrice || promotion.IsBonusOffer || promotion.IsProductGroupPercentageOff || promotion.IsDeferred || promotion.IsR1Promotion; });
    if (matchedPromotion) {
        this.removeInlineMessage(trolleyItem.Stockcode, 'MissedPromotion');
        if ((matchedPromotion.IsDeferred) || (matchedPromotion.IsR1Promotion)) {
            const self = this;
            this.addInlineMessage(trolleyItem.Stockcode, 'MatchedPromotion', {
                isDismissable: true,
                class: 'matchedPromotion',
                templateId: 'matched-promotion',
                promotionDescription: self.$sce.trustAsHtml(matchedPromotion.Description)
            });
        } else {
            this.addInlineMessage(trolleyItem.Stockcode, 'MatchedPromotion', {
                isDismissable: true,
                class: 'matchedPromotion',
                templateId: 'matched-promotion',
                promotionDescription: `You've saved ${this._currencyFilter(trolleyItem.ListPrice * trolleyItem.Quantity - trolleyItem.SalePrice)}`
            });
        }
    } else {
        this.removeInlineMessage(trolleyItem.Stockcode, 'MatchedPromotion');
    }
};

InlineMessageService.prototype.initErrorMessages = function (trolleyItem, deliveryPassLimitMessage) {
    const self = this;
    if (trolleyItem.HasError === 'false') {
        // Item has changed and is now valid; clear all quantity notifications
        this.removeInlineMessage(trolleyItem.Stockcode, 'QtyIsGreater');
        this.removeInlineMessage(trolleyItem.Stockcode, 'InvalidQuantity');
        this.removeInlineMessage(trolleyItem.Stockcode, 'DeliveryPassLimit');
    } else {
        // Quanity Notification [Invalid value]
        if (trolleyItem.HasError === 'Invalid') {
            // Remove other error from message stack
            this.removeInlineMessage(trolleyItem.Stockcode, 'QtyIsGreater');
            this.removeInlineMessage(trolleyItem.Stockcode, 'DeliveryPassLimit');
            // Add new message
            this.addInlineMessage(trolleyItem.Stockcode, 'InvalidQuantity', {
                    isDismissable: true,
                    class: 'errorQuantity',
                    templateId: 'error-quantity',
                    errorMessage: self.$sce.trustAsHtml('Item not updated.<br/>Please review and update quantity.')
                },
                true);
        }

        // Quanity Notifications [Quantity is greater than product limit value]
        if (trolleyItem.HasError === 'QtyIsGreater') {
            // Remove other error from message stack
            this.removeInlineMessage(trolleyItem.Stockcode, 'InvalidQuantity');
            this.removeInlineMessage(trolleyItem.Stockcode, 'DeliveryPassLimit');
            // Add new message
            this.addInlineMessage(trolleyItem.Stockcode, 'QtyIsGreater', {
                    isDismissable: true,
                    class: 'errorQuantity',
                    templateId: 'error-quantity',
                    errorMessage: self.$sce.trustAsHtml(`This item has a limit of ${parseInt(trolleyItem.ProductData.maxpurchasequantity || trolleyItem.SupplyLimit)}.<br/>The quantity in your trolley has been updated accordingly.`)
                },
                true);
        }

        // Delivery Pass limit notifications [if customer exceeds delivery pass limit]
        if (trolleyItem.HasError === 'DeliveryPassLimit') {
            // Remove other error from message stack
            this.removeInlineMessage(trolleyItem.Stockcode, 'QtyIsGreater');
            this.removeInlineMessage(trolleyItem.Stockcode, 'InvalidQuantity');
            // Add new message
            self.addInlineMessage(trolleyItem.Stockcode, 'DeliveryPassLimit', {
                    isDismissable: true,
                    class: 'errorQuantity',
                    templateId: 'error-quantity',
                    errorMessage: self.$sce.trustAsHtml(deliveryPassLimitMessage)
                },
                true);
        }

        // clear this flag so it won't be re-added in any filter scenario
        trolleyItem.HasError = '';
    }
};

// Initialise any trolley item messages
InlineMessageService.prototype.initItemMessages = function (trolleyItem, deliveryPassLimitMessage) {
    // Add messages in order you want them to apear, from lowest to highest priority

    // Missed multibuy promotion
    this.initMissedPromotions(trolleyItem);

    // Matched multibuy promotion
    this.initMatchedPromotions(trolleyItem);

    // init any error messages
    this.initErrorMessages(trolleyItem, deliveryPassLimitMessage);
};

module.exports = InlineMessageService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/inline-message-service.js
 **/